module.exports = __webpack_public_path__ + "static/img/aboutUs08.bb28476.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/aboutUs08.jpg
// module id = 1360
// module chunks = 1